import { TnError } from './TnError';

export interface TnErrorFamilyNameNotFoundData {
    // the family name we use in the database.
    familyName: string;
}

/**
 * This exception is thrown anytime a family is queried, but we're unable to get it.
 */
export class TnErrorFamilyNameNotFound extends TnError<TnErrorFamilyNameNotFoundData> {
    public type = 'familyNotFound';
    constructor(familyName: string) {
        super(`Family ${familyName} not found`, { familyName });
    }
}

export interface TnErrorStyleNameNotFoundData {
    familyName: string;
    styleName: string;
}
export class TnErrorStyleNameNotFound extends TnError<TnErrorStyleNameNotFoundData> {
    public type = 'styleNotFound';
    constructor(styleName: string, familyName: string) {
        super(`Style ${styleName} not found`, { styleName, familyName });
    }
}

export class TnErrorStyleIdNotFound extends TnError<{ styleId: string }> {
    public type = 'styleIdNotFound';
    constructor(styleId: string) {
        super(`Style ${styleId} not found`, { styleId });
    }
}
